// extracted by mini-css-extract-plugin
export default {"container":"travelPage_container__eyQY0","countries":"travelPage_countries__MiBKW","continents":"travelPage_continents__gXgxO"};